/**
 * Emergency email control (Spec 255).
 *
 * Flips the master notification-email gates in dbo.global_settings via the admin-only
 * feature-flag endpoint. Setting `alert_email_enabled=false` stops EVERY notification email
 * stream (escalation, digest, pipeline, resolve-nudge, KPI) on the next sweep tick — the gates
 * read settings fresh each tick (no cache), so no restart or container shutdown is needed.
 *
 * The notification-engine master is kept in lockstep so "on" means every stream works and
 * "off" means everything is silent.
 */
import { apiClient } from './apiClient';

const EMAIL_KEY = 'alert_email_enabled';
const ENGINE_KEY = 'notification_engine_enabled';

async function readFlag(key: string): Promise<boolean> {
  const res = await apiClient.get<{ data?: { value?: boolean } }>(`/api/settings/feature-flags/${key}`);
  return Boolean(res.data?.data?.value);
}

/** Current master email state (drives the ON/OFF switch). */
export async function getEmailNotificationsEnabled(): Promise<boolean> {
  return readFlag(EMAIL_KEY);
}

/** Turn ALL notification email on or off (master gate + engine master, in lockstep). */
export async function setEmailNotificationsEnabled(value: boolean): Promise<void> {
  await apiClient.put(`/api/settings/feature-flags/${EMAIL_KEY}`, { value });
  await apiClient.put(`/api/settings/feature-flags/${ENGINE_KEY}`, { value });
}
